import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { NotificationFeed } from '@/app/MagicBell/NotificationFeed/NotificationFeed';
import { ProjectsHomePage } from '@/areas/home/Home/ProjectsHomePage/ProjectsHomePage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/home')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ProjectsHomePage NotificationFeed={NotificationFeed} />;
}
